<template>
    <v-container fluid>
        <div v-if="!loading">    
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Segments actual peak size
            </v-row>
            <v-divider />
            <!--table head-->
            <v-row class="subtitle-2" no-gutters>
                <v-col v-for="(item, i) in headers" :key="i" 
                    class="tabCell"
                    :class="item.style">
                    {{ item.title }}
                </v-col>
            </v-row>
            <!--market tab-->
            <div v-if="market_segments.length" >       
                <v-row v-for="segment in market_segments"
                    :key="segment.id" no-gutters>
                    <v-col class="tabCell text-truncate text-left">{{ segment.segment?.name }}</v-col>
                    <v-col class="tabCell text-center">{{ localeNumber(segment.segment?.peak_size) }}</v-col>
                    <v-col class="tabCell text-center">{{ localeNumber(segment.actual_size) }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.max_price }}</v-col>
                    <v-col class="tabCell text-center">{{ segment.min_price }}</v-col>
                </v-row>
            </div>
            <v-row v-else class="mt-4"
                justify="center">
                there are no segments yet
            </v-row>
        </div>
        <!--!loading-->
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>
import Loader from '../../../layouts/Loader.vue';
import { localeNumber } from '../../../functions/common';
export default {
    data() {
        return {
            headers: [
                { title: 'Segment', style: 'text-left' },
                { title: 'Market size', style: 'text-center' },
                { title: 'Actual market size', style: 'text-center' },
                { title: 'Max price', style: 'text-center' },
                { title: 'Min price', style: 'text-center' },
            ],
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        market_segments() {
            return this.$store.getters.market_segments;
        },
    },
    methods: {
        localeNumber(number) {
            return localeNumber(number, this.locale)
        }
    },
    components: { Loader }
}
</script>
